import { FitlineClubMemberBadge } from 'components/badges/fitline-club-member/FitlineClubMemberBadge';
import { IUserProfile } from 'types';

export function FitlineClubMemberColumn(props: {
  readonly userProfile: IUserProfile;
}) {
  if (props.userProfile.isFitlineClubMember) {
    return <FitlineClubMemberBadge />;
  }

  return <span></span>;
}
